<script setup lang="ts">
import { RouterLink, type RouteLocationRaw } from 'vue-router';
import type { PdsIconName } from './icons';
import PdsIcon from './PdsIcon.vue';

defineProps<{
  icon: PdsIconName;
  label: string;
  disabled?: boolean;
  to?: RouteLocationRaw;
}>();
</script>

<template>
  <component
    :is="to ? RouterLink : 'button'"
    :to="to"
    :type="to ? undefined : 'button'"
    :aria-label="label"
    :disabled="to ? undefined : disabled"
    class="bg-creux text-encre flex size-12 shrink-0 cursor-pointer items-center justify-center rounded-[24px] disabled:cursor-not-allowed disabled:opacity-50"
  >
    <PdsIcon :name="icon" />
  </component>
</template>
